import React, { Suspense } from 'react';

const BaseLayout = React.lazy(() => import('./BaseLayout'));

const BaseLayoutAsync = ({ children, ...props }) => {
  return (
    <Suspense fallback="">
      <BaseLayout {...props}>{children}</BaseLayout>
    </Suspense>
  );
};

export default BaseLayoutAsync;
